import React from "react";

export const Four = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
       width="52"
        height="52"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M1.99961 9.95001C1.39961 9.95001 0.849609 10.45 0.849609 11.1V20.95C0.849609 21.55 1.34961 22.1 1.99961 22.1C2.64961 22.1 3.14961 21.6 3.14961 20.95V11.1C3.14961 10.45 2.59961 9.95001 1.99961 9.95001Z"
          fill="url(#paint0_linear_272_12172)"
        />
        <path
          d="M7.59922 7.30005C6.99922 7.30005 6.44922 7.80005 6.44922 8.45005V23.6C6.44922 24.2 6.94922 24.75 7.59922 24.75C8.24922 24.75 8.74922 24.25 8.74922 23.6V8.40005C8.74922 7.80005 8.19922 7.30005 7.59922 7.30005Z"
          fill="url(#paint1_linear_272_12172)"
        />
        <path
          d="M13.1988 2.15002C12.5988 2.15002 12.0488 2.65002 12.0488 3.30002V28.75C12.0488 29.35 12.5488 29.9 13.1988 29.9C13.8488 29.9 14.3488 29.4 14.3488 28.75V3.30002C14.2988 2.65002 13.7988 2.15002 13.1988 2.15002Z"
          fill="url(#paint2_linear_272_12172)"
        />
        <path
          d="M18.8004 10.3C18.2004 10.3 17.6504 10.8 17.6504 11.45V20.65C17.6504 21.25 18.1504 21.8 18.8004 21.8C19.4504 21.8 19.9504 21.3 19.9504 20.65V11.4C19.9004 10.8 19.4004 10.3 18.8004 10.3Z"
          fill="url(#paint3_linear_272_12172)"
        />
        <path
          d="M24.4 6.20001C23.8 6.20001 23.25 6.70001 23.25 7.35001V24.65C23.25 25.25 23.75 25.8 24.4 25.8C25.05 25.8 25.55 25.3 25.55 24.65V7.35001C25.5 6.70001 25 6.20001 24.4 6.20001Z"
          fill="url(#paint4_linear_272_12172)"
        />
        <path
          d="M29.9996 12.2C29.3996 12.2 28.8496 12.7 28.8496 13.35V18.7C28.8496 19.3 29.3496 19.85 29.9996 19.85C30.6496 19.85 31.1496 19.35 31.1496 18.7V13.3C31.1496 12.7 30.5996 12.2 29.9996 12.2Z"
          fill="url(#paint5_linear_272_12172)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_272_12172"
            x1="1.99961"
            y1="9.95001"
            x2="1.99961"
            y2="24.6706"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="0.744792"
              stop-color="white"
              stop-opacity="0.364583"
            />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_272_12172"
            x1="7.59922"
            y1="7.30005"
            x2="7.59922"
            y2="28.442"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="0.744792"
              stop-color="white"
              stop-opacity="0.364583"
            />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_272_12172"
            x1="13.1988"
            y1="2.15002"
            x2="13.1988"
            y2="35.7711"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="0.744792"
              stop-color="white"
              stop-opacity="0.364583"
            />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_272_12172"
            x1="18.8004"
            y1="10.3"
            x2="18.8004"
            y2="24.2331"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="0.744792"
              stop-color="white"
              stop-opacity="0.364583"
            />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_272_12172"
            x1="24.4"
            y1="6.20001"
            x2="24.4"
            y2="29.9468"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="0.744792"
              stop-color="white"
              stop-opacity="0.364583"
            />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_272_12172"
            x1="29.9996"
            y1="12.2"
            x2="29.9996"
            y2="21.4685"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="0.744792"
              stop-color="white"
              stop-opacity="0.364583"
            />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
